import { FormControl } from "@chakra-ui/react";
import { useSlide } from "../public/slide";
import { SlidePropsEmail } from "../public/types";
import { EmailState, useQuizActions, useQuizSnapshot } from "./state";
import { commonInputStyles } from "./commonInput";
import { MyFormLabel } from "./ui";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { EmailInput, EmailInputHandle } from "@base/lib/email-lib";

export type Email = {} & SlidePropsEmail;

export function Email({ placeholder, label }: Email) {
  const [localEmailValue, setLocalEmailValue] = useState("");
  const emailInputRef = useRef<EmailInputHandle>(null);

  const actions = useQuizActions();
  const slide = useSlide();
  const snap = useQuizSnapshot();
  const { t } = useTranslation();

  const state = snap.slideStateByID[slide.id] as EmailState;

  // Hold the submit once when a typo suggestion exists, so clicking the CTA
  // while the input is still focused can't skip past "did you mean …?".
  useEffect(() => {
    actions.registerSubmitGate(slide.id, () => emailInputRef.current?.confirmSubmit() ?? true);
    return () => actions.unregisterSubmitGate(slide.id);
  }, [actions, slide.id]);

  return (
    <FormControl>
      {label && <MyFormLabel>{label}</MyFormLabel>}

      <EmailInput
        ref={emailInputRef}
        value={localEmailValue}
        onChange={(value) => {
          setLocalEmailValue(value);
          actions.setEmailValue(slide.id, value);
        }}
        placeholder={placeholder}
        isInvalid={!state.isValueValid && state.attempts > 0}
        errorMessage={t("quizLib.email.error", {
          defaultValue: "Please enter a valid email address",
        })}
        trackingContext="quiz"
        dataTestId="quiz-email-input"
        inputProps={commonInputStyles()}
      />
    </FormControl>
  );
}
